import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Destinations from "@/components/Destinations";
import Testimonials from "@/components/Testimonials";
import ClientReviews from "@/components/ClientReviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminDashboard from "@/pages/AdminDashboard";

function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );

    const observeAll = () => {
      document.querySelectorAll(".reveal:not(.visible)").forEach((el) => {
        observer.observe(el);
      });
    };

    observeAll();

    // Re-scan whenever new .reveal nodes (e.g. async-loaded service rows) appear
    const mo = new MutationObserver(() => observeAll());
    mo.observe(document.body, { childList: true, subtree: true });

    // Safety fallback: reveal anything left after 2.5s (e.g. very tall pages,
    // failed observer hits) so content is never permanently hidden.
    const fallback = setTimeout(() => {
      document.querySelectorAll(".reveal:not(.visible)").forEach((el) => {
        el.classList.add("visible");
      });
    }, 2500);

    return () => {
      observer.disconnect();
      mo.disconnect();
      clearTimeout(fallback);
    };
  }, []);
}

const Home = () => {
  useScrollReveal();
  return (
    <div className="App" data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <Destinations />
        <Testimonials />
        <ClientReviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121623",
            color: "#F0EBE1",
            border: "1px solid rgba(240,235,225,0.1)",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
